import { createFileRoute, Outlet } from '@tanstack/react-router';
import { NoAccess } from '@/components/custom/no-access';
import { useMe } from '@/lib/me';

/**
 * Dashboards live under `/dashboard/{id}`.
 *
 * Deliberately absent from the sidebar (`lib/navigation.ts`) while the tiles
 * still render fixture data — the route is reachable only by typing the URL.
 *
 * Gated on `report.view` AND `dashboard.view`, the same pair as `/dashboards`.
 * `report.view` is the one carrying the row scopes (all / my_organization /
 * my_teams) these queries read; `dashboard.view` is what a tenant sets to keep
 * the dashboard surfaces out of a role's hands without also taking Reports
 * away. This route used to ask for `report.view` alone and noted that a
 * dedicated `dashboard.view` could be introduced later if the two surfaces
 * needed to diverge — they did, and it is here. Keeping both surfaces on the
 * same pair is what stops this url from being the way around the sidebar gate.
 */
export const Route = createFileRoute('/_authenticated/dashboard')({
  component: DashboardLayout,
});

function DashboardLayout() {
  const { permissions, loading } = useMe();

  if (!loading && !permissions.has('report.view')) {
    return <NoAccess permission="report.view" resource="dashboards" />;
  }

  if (!loading && !permissions.has('dashboard.view')) {
    return <NoAccess permission="dashboard.view" resource="dashboards" />;
  }

  return <Outlet />;
}
